import { Box, Container, Heading, Stack } from '@hover/blueprint';
import { Button } from '@hover/blueprint/brand';
import { navigate } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { SCHEDULE_A_MEETING_LINK } from '../../../constants';
import { DownloadAppModal } from '../../common';
import ArrowButton from '../../ui/ArrowButton';

const PricingGettingStarted: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => setIsOpen(!isOpen);

  const navigateTo = () => navigate(SCHEDULE_A_MEETING_LINK);
  return (
    <>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Container
        maxW="100%"
        py={1000}
        bg="brandNavy.500"
        centerContent
        px={{ base: 800, tablet: '56px', desktop: 500 }}
      >
        <Stack
          maxW="1200px"
          spacing={{ base: 700, desktop: 1100 }}
          direction={{ base: 'column', desktop: 'row' }}
          alignItems="center"
          w="100%"
        >
          <Box w="379px" h="295px" px={{ base: 500, tablet: 0 }}>
            <StaticImage
              quality={100}
              placeholder="blurred"
              src="../../../assets/images/pricing_page_footer_home.png"
              alt="pricing page footer"
              objectFit="contain"
            />
          </Box>
          <Box flexDir="column" w={{ base: '100%', desktop: 'auto' }}>
            <Heading
              size={{ base: 500, tablet: 600, desktop: 700 }}
              fontWeight={{ base: 700, desktop: 700 }}
              marginBottom={{ base: 500, desktop: 500 }}
              color="neutral.0"
              textAlign={{ base: 'center', desktop: 'left' }}
            >
              Getting started is quick.
            </Heading>
            <Heading
              size={{ base: 300, tablet: 500, desktop: 500 }}
              isDisplay
              marginBottom={{ base: 700, desktop: 700 }}
              color="neutral.0"
              textAlign={{ base: 'center', desktop: 'left' }}
            >
              Go way beyond measurements in minutes.
            </Heading>
            <Stack
              direction={{ base: 'column', desktop: 'row' }}
              spacing={{ base: 500, desktop: 400 }}
              alignItems="center"
            >
              <Button
                colorScheme="brandNavy"
                w={{ base: '100%', tablet: 'auto' }}
                variant="inverted"
                onClick={toggleModal}
              >
                Try for free
              </Button>
              <ArrowButton
                w={{ base: '100%', tablet: 'auto' }}
                variant="minimal"
                colorScheme="neutral"
                onClick={navigateTo}
                // TODO(buttons): remove when we remove padding in Blueprint
                sx={{ div: { pl: 100, pr: 50 } }}
              >
                Schedule a demo
              </ArrowButton>
            </Stack>
          </Box>
        </Stack>
      </Container>
    </>
  );
};

export default PricingGettingStarted;
